import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      quote: "The hospitality website developed by Ehsan Traders for our Dubai venture is exceptional. The booking flow and UI are world-class.",
      author: "Ram Kumar",
      title: "Hospitality Lead | Dubai, UAE",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg"
    },
    {
      id: 2,
      quote: "Ehsan Traders built a specialized platform for our Stamp Business in Abu Dhabi. Their attention to local business needs is impressive.",
      author: "Faizan Khan",
      title: "Founder, Stamp Solutions | Abu Dhabi",
      avatar: "https://randomuser.me/api/portraits/men/46.jpg"
    },
    {
      id: 3,
      quote: "The Electron-based POS system created for my clinic is robust and fast. It has completely digitized our patient management.",
      author: "Dr. Aizaz",
      title: "Medical Specialist | POS Client",
      avatar: "https://randomuser.me/api/portraits/men/52.jpg"
    },
    {
      id: 4,
      quote: "Our cleaning service platform in Sharjah saw an immediate increase in conversions after the new site launched. Highly recommended.",
      author: "Saad Ayaz",
      title: "Director, Cleaning Services | Sharjah",
      avatar: "https://randomuser.me/api/portraits/men/22.jpg"
    },
    {
      id: 5,
      quote: "A professional and seamless website for our moving business in Abu Dhabi. They handled the SEO and design perfectly.",
      author: "Logistics Partner",
      title: "Movers & Packers | Abu Dhabi",
      avatar: "https://randomuser.me/api/portraits/men/36.jpg"
    },
    {
      id: 6,
      quote: "The 'Health Flow' desktop app is a game-changer for my practice in Mardan. Efficient, secure, and very user-friendly.",
      author: "Dr. Ram Kumar",
      title: "Lead Clinician | Mardan, PK",
      avatar: "https://randomuser.me/api/portraits/men/85.jpg"
    }
  ];

  return (
    <section id="testimonials" className="py-20 md:py-32 bg-[#F8FAFC]">
      <div className="container mx-auto px-6 md:px-12">
        
        {/* Header - Added responsive text sizing */}
        <div className="mb-12 md:mb-16 text-center">
          <span className="text-[#D62828] font-bold uppercase tracking-[0.4em] text-[10px] md:text-xs">Global Success Stories</span>
          <h2 className="text-4xl md:text-5xl font-black text-[#0A1D37] mt-3 uppercase tracking-tighter">
            Trusted <span className="text-transparent" style={{ WebkitTextStroke: '1px #0A1D37' }}>Worldwide</span>
          </h2>
          <div className="h-1.5 w-20 bg-[#D62828] mt-6 mx-auto"></div>
        </div>

        {/* Swiper Slider */}
        <Swiper
          spaceBetween={20} // Reduced gap for mobile
          slidesPerView={1}
          centeredSlides={false}
          loop={true}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
          breakpoints={{
            768: { 
              slidesPerView: 2,
              spaceBetween: 30 
            },
            1024: { 
              slidesPerView: 3,
              spaceBetween: 30 
            },
          }}
          modules={[Autoplay, Pagination]}
          className="mySwiper !pb-20"
        >
          {testimonials.map((testimonial) => (
            <SwiperSlide key={testimonial.id} className="h-auto">
              <div className="bg-white p-8 md:p-10 shadow-xl border-t-4 border-[#D62828] h-full flex flex-col justify-between hover:-translate-y-2 transition-transform duration-300">
                <div>
                  <div className="flex text-[#D62828] mb-6 text-[10px] md:text-xs">
                    <i className="fas fa-star mr-1"></i>
                    <i className="fas fa-star mr-1"></i>
                    <i className="fas fa-star mr-1"></i>
                    <i className="fas fa-star mr-1"></i>
                    <i className="fas fa-star mr-1"></i>
                  </div>
                  <p className="text-slate-700 leading-relaxed italic text-base md:text-lg mb-8">
                    "{testimonial.quote}"
                  </p>
                </div>
                
                <div className="flex items-center pt-6 border-t border-slate-100">
                  <img 
                    src={testimonial.avatar} 
                    alt={testimonial.author} 
                    className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover mr-4 grayscale hover:grayscale-0 transition-all shadow-md"
                  />
                  <div className="overflow-hidden">
                    <h4 className="text-[#0A1D37] font-black text-xs md:text-sm uppercase tracking-tight truncate">
                      {testimonial.author}
                    </h4>
                    <p className="text-[#D62828] font-bold text-[9px] md:text-[10px] uppercase tracking-widest mt-1 truncate">
                      {testimonial.title}
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;